import * as React from 'react';
import { ThemeOptions, ThemeProvider, createTheme } from '@mui/material/styles';
//import { inputsCustomizations } from './customizations/inputs';
//import { dataDisplayCustomizations } from './customizations/dataDisplay';
//import { feedbackCustomizations } from './customizations/feedback';
//import { navigationCustomizations } from './customizations/navigation';
//import { surfacesCustomizations } from './customizations/surfaces';
//import { colorSchemes, typography, shadows, shape } from '../../../temp/themePrimitives';
import { red } from '@mui/material/colors';
import { enUS, itIT, ptPT } from '@mui/material/locale'; // #POW-29
import { enUS as dataGridEnUS, itIT as dataGridItIT, ptPT as dataGridPtPT } from '@mui/x-data-grid/locales'; // #POW-29
import { createContext, useEffect, useState } from 'react'; // #POW-29
import { Localization } from '@mui/x-data-grid/internals'; // #POW-29
import { useTranslation } from "react-i18next"; // #POW-37
import { Alert, Snackbar } from '@mui/material';

// #POW-29
interface ThemeContextType {
  localeValue: string;
  setLocalizations: (locale: string) => void;
  setShowFailure:(message: string) => void;
}

export const ThemeContext = createContext<ThemeContextType>({localeValue: "en", setLocalizations: () => {}, setShowFailure: () => {}}); // #POW-29
interface AppThemeProps {
  children: React.ReactNode;
}

export default function AppThemes(props: AppThemeProps) {

  const [localeValue, setLocaleValue] = useState<string>("en"); // #POW-29
  const [locale, setLocale] = useState<ThemeOptions>(enUS); // #POW-29
  const [dataGridLocale, setDataGridLocale] = useState<Localization>(dataGridEnUS); // #POW-29
  const [open, setOpen ] = useState(false)
  const [failureMessage, setFailureMessage ] = useState('')

  const { i18n, t } = useTranslation(); // #POW-37
  
  // #POW-29
  const localizationsMapping: { [key: string]: {"locale": ThemeOptions, "dataGridLocale": Localization} } = {
    "en": {"locale": enUS, "dataGridLocale": dataGridEnUS},
    "it": {"locale": itIT, "dataGridLocale": dataGridItIT},
    "pt": {"locale": ptPT, "dataGridLocale": dataGridPtPT}
  };
  
  useEffect(() => { // #POW-37
    if (localizationsMapping[i18n.language]) {
      setLocaleValue(i18n.language)
      setLocale(localizationsMapping[i18n.language].locale);
      setDataGridLocale(localizationsMapping[i18n.language].dataGridLocale);
    }
  }, [i18n.language]);
  

  // #POW-29
  const setLocalizations = (locale: string) => {
    i18n.changeLanguage(locale); // #POW-37
  };
  
  const setShowFailure = (message: string) => {
    setFailureMessage(t(message))
    setOpen(true)
    setTimeout(() => { setOpen(false) }, 2000)
  }

  const { children } = props;
  
  const theme = createTheme(
    {
      cssVariables: true,
      //cssVarPrefix: 'template',
      palette: {
        primary: {
          main: '#556cd6',
        },
        secondary: {
          main: '#19857b',
        },
        error: {
          main: red.A400,
        },
      },
    },
    locale, // #POW-29
    dataGridLocale // #POW-29
  )
  // -- ???? createTheme({
  // -- ????   // For more details about CSS variables configuration, see https://mui.com/material-ui/customization/css-theme-variables/configuration/
  // -- ????   cssVariables: {
  // -- ????     colorSchemeSelector: 'data-mui-color-scheme',
  // -- ????     cssVarPrefix: 'template',
  // -- ????   },
  // -- ????   colorSchemes, // Recently added in v6 for building light & dark mode app, see https://mui.com/material-ui/customization/palette/#color-schemes
  // -- ????   typography,
  // -- ????   shadows,
  // -- ????   shape,
  // -- ????   components: {
  // -- ????     //...inputsCustomizations,
  // -- ????     //...dataDisplayCustomizations,
  // -- ????     //...feedbackCustomizations,
  // -- ????     //...navigationCustomizations,
  // -- ????     //...surfacesCustomizations,
  // -- ????     ...themeComponents,
  // -- ????   },
  // -- ???? });

  return (
    <ThemeContext.Provider value={{ localeValue, setLocalizations, setShowFailure }}> {/* #POW-29 */}
      <ThemeProvider theme={theme} disableTransitionOnChange>
        {children}
        <Snackbar open={open} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert
            severity="error"
            variant="filled"
            sx={{ width: '100%' }}
          >
            {failureMessage}
          </Alert>
        </Snackbar>
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}
